import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";

export default function Impressum() {
    return (
        <div data-testid="impressum-page" className="bg-aimploy-bg">
            {/* HERO */}
            <section className="pt-24 lg:pt-32 pb-12 bg-aimploy-bg relative overflow-hidden">
                <div className="absolute -top-40 -right-40 h-[400px] w-[400px] rounded-full bg-aimploy-violet/10 blur-3xl" />
                <div className="relative max-w-[900px] mx-auto px-6 lg:px-12">
                    <span className="text-xs uppercase tracking-[0.2em] text-aimploy-violet font-semibold">
                        Rechtliches
                    </span>
                    <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-[0.95] tracking-tight mt-6">
                        Impressum
                    </h1>
                    <p className="text-aimploy-muted mt-6 max-w-xl">
                        Angaben gemäß §5 TMG.
                    </p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="pb-24 lg:pb-32 bg-aimploy-bg">
                <div className="max-w-[900px] mx-auto px-6 lg:px-12">
                    <div className="bg-white rounded-3xl p-8 lg:p-12 border border-black/5 space-y-12">

                        {/* Anbieter */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">Anbieter</h2>
                            <address className="not-italic text-aimploy-muted leading-relaxed">
                                <strong className="text-aimploy-navy block mb-1">Aimploy UG (haftungsbeschränkt)</strong>
                                Leopoldstraße 2–8<br />
                                32051 Herford<br />
                                Deutschland
                            </address>
                        </div>

                        {/* Vertretung */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">Vertretungsberechtigter Geschäftsführer</h2>
                            <p className="text-aimploy-muted">Daniel Herter</p>
                        </div>

                        {/* Handelsregister */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">Handelsregister</h2>
                            <ul className="space-y-1 text-aimploy-muted">
                                <li><span className="text-aimploy-navy font-semibold">Registergericht:</span> Bad Oeynhausen</li>
                                <li><span className="text-aimploy-navy font-semibold">Registernummer:</span> HRB 20591</li>
                            </ul>
                        </div>

                        {/* Kontakt */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">Kontakt</h2>
                            <ul className="space-y-3 text-aimploy-muted">
                                <li className="flex items-start gap-3">
                                    <Mail className="w-4 h-4 text-aimploy-violet mt-1 flex-shrink-0" />
                                    <a href="mailto:kontakt@aimploy.de" className="hover:text-aimploy-violet">kontakt@aimploy.de</a>
                                </li>
                                <li className="flex items-start gap-3">
                                    <Phone className="w-4 h-4 text-aimploy-violet mt-1 flex-shrink-0" />
                                    <a href="tel:+491753669882" className="hover:text-aimploy-violet">+49 1753669882</a>
                                </li>
                                <li className="flex items-start gap-3">
                                    <MapPin className="w-4 h-4 text-aimploy-violet mt-1 flex-shrink-0" />
                                    Leopoldstraße 2–8, 32051 Herford
                                </li>
                            </ul>
                        </div>

                        {/* Verantwortlich */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">
                                Verantwortlich für den Inhalt nach §18 Abs. 2 MStV
                            </h2>
                            <p className="text-aimploy-muted">
                                Daniel Herter<br />
                                Aimploy UG (haftungsbeschränkt)<br />
                                Leopoldstraße 2–8, 32051 Herford
                            </p>
                        </div>

                        {/* Streitschlichtung */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">EU-Streitschlichtung</h2>
                            <p className="text-aimploy-muted leading-relaxed">
                                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                                <a
                                    href="https://ec.europa.eu/consumers/odr/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-aimploy-violet hover:underline inline-flex items-center gap-1"
                                >
                                    https://ec.europa.eu/consumers/odr/
                                    <ArrowUpRight className="w-3.5 h-3.5" />
                                </a>
                                . Unsere E-Mail-Adresse finden Sie oben im Impressum.
                            </p>
                            <p className="text-aimploy-muted leading-relaxed mt-4">
                                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                                Verbraucherschlichtungsstelle teilzunehmen.
                            </p>
                        </div>

                        {/* Haftung */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">Haftung für Inhalte</h2>
                            <p className="text-aimploy-muted leading-relaxed">
                                Als Diensteanbieter sind wir gemäß §7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
                                allgemeinen Gesetzen verantwortlich. Nach §§8 bis 10 TMG sind wir als Diensteanbieter jedoch
                                nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder
                                nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                            </p>
                            <p className="text-aimploy-muted leading-relaxed mt-4">
                                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
                                Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
                                der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                                Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                            </p>
                        </div>

                        {/* Haftung Links */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">Haftung für Links</h2>
                            <p className="text-aimploy-muted leading-relaxed">
                                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss
                                haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
                                verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
                                Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
                                erkennbar.
                            </p>
                            <p className="text-aimploy-muted leading-relaxed mt-4">
                                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen
                                werden wir derartige Links umgehend entfernen.
                            </p>
                        </div>

                        {/* Urheberrecht */}
                        <div>
                            <h2 className="font-display text-2xl font-bold mb-4">Urheberrecht</h2>
                            <p className="text-aimploy-muted leading-relaxed">
                                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
                                deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
                                jeweiligen Autors bzw. Erstellers.
                            </p>
                            <p className="text-aimploy-muted leading-relaxed mt-4">
                                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
                                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
                                Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
                                umgehend entfernen.
                            </p>
                        </div>

                    </div>

                    <div className="mt-10 text-center">
                        <Link
                            to="/"
                            data-testid="impressum-back-home"
                            className="inline-flex items-center gap-2 text-sm text-aimploy-muted hover:text-aimploy-navy"
                        >
                            ← Zurück zur Startseite
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
